/**
 * 推荐位条件枚举
 * key: 推荐位编码 slotCode
 * value: 该推荐位下的条件列表（condition 条件序号 / label 条件描述）
 */
export const SLOT_CONDITIONS_MAP = {
    SD_RP_BS_001: [
        { condition: 1, label: '进入SD卡回放，SD卡磁盘空间>80%且7≤存储天数＜15 且未开通云存储服务' },
        { condition: 2, label: '进入SD卡回放，SD卡磁盘空间>80%且存储天数＜7 且未开通云存储服务' },
    ],
    CS_RP_BS_002: [
        { condition: 1, label: '云回放-未开通云存储服务且未插入SD卡' },
    ],
    ALL_HOME_BS_003: [
        { condition: 1, label: '进入首页；未开通云存储服务设备数>3' },
        { condition: 2, label: '进入首页；未开通云存储服务设备数=1' },
        { condition: 3, label: '进入首页；未开通云存储服务设备数=2或=3' },
    ],
};

/**
 * 根据推荐位编码获取对应的条件列表
 * @param {string} slotCode
 * @returns {Array<{condition:number,label:string}>}
 */
export function getSlotConditions(slotCode) {
    return SLOT_CONDITIONS_MAP[slotCode] || [];
}

export const CONDITION_CN_NUMS = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
